module.exports = __webpack_public_path__ + "static/media/xgmm.32fa87a6.svg";